import React, { useState, useEffect } from "react";
import { adminUpdateSubAdmin } from "../api/admin";
import { toast } from "react-toastify";
import "./PermissionModal.css";

const modules = [
    { id: "Dashboard", name: "Dashboard" },
    { id: "Users", name: "Users" },
    { id: "Products", name: "Products" },
    { id: "Variants", name: "Variants" },
    { id: "Categories", name: "Categories" },
    { id: "Subcategories", name: "Subcategories" },
    { id: "Orders", name: "Orders" },
    { id: "Banners", name: "Banners" },
    { id: "Blogs", name: "Blogs" },
    { id: "Shipping", name: "Shipping" },
    { id: "Wallet", name: "Wallet" },
    { id: "Contacts", name: "Contacts" },
    { id: "Settings", name: "Settings" },
];

const PermissionModal = ({ subadmin, onClose, onSuccess }) => {
    // Permissions are stored as ["Module:read", "Module:write"]
    const [permissions, setPermissions] = useState(subadmin?.permissions || []);
    const [loading, setLoading] = useState(false);

    const togglePermission = (moduleId, type) => {
        const permString = `${moduleId}:${type}`;
        setPermissions(prev => {
            if (prev.includes(permString)) {
                return prev.filter(p => p !== permString);
            } else {
                // If adding write, also add read for consistency
                if (type === "write" && !prev.includes(`${moduleId}:read`)) {
                    return [...prev, permString, `${moduleId}:read`];
                }
                return [...prev, permString];
            }
        });
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            const subadminId = subadmin._id || subadmin.id;
            await adminUpdateSubAdmin(subadminId, { permissions });
            toast.success(`Permissions updated for ${subadmin.name}! 🛡️`);
            onSuccess();
        } catch (error) {
            console.error(error);
            toast.error("Failed to update permissions.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="permission-manager-container">
            <div className="permission-card">
                <div className="modal-body" style={{ padding: 0 }}>
                    <table className="permission-table luxury-table">
                        <thead>
                            <tr>
                                <th>Module Name</th>
                                <th style={{ textAlign: 'center' }}>Read Access</th>
                                <th style={{ textAlign: 'center' }}>Write Access</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modules.map((mod) => (
                                <tr key={mod.id}>
                                    <td className="module-name-cell">{mod.name}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <label className="checkbox-container">
                                            <input 
                                                type="checkbox" 
                                                checked={permissions.includes(`${mod.id}:read`)}
                                                onChange={() => togglePermission(mod.id, "read")}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <label className="checkbox-container">
                                            <input 
                                                type="checkbox" 
                                                checked={permissions.includes(`${mod.id}:write`)}
                                                onChange={() => togglePermission(mod.id, "write")}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="form-footer" style={{ marginTop: '30px', padding: 0, border: 'none' }}>
                    <button className="btn-submit" onClick={handleSave} disabled={loading}>
                        {loading ? "Saving..." : "Save Permissions"}
                    </button>
                    <button className="btn-cancel" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default PermissionModal;
